/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { icons } from "src/environments/config";
import { setActualDimensions } from "../../liveshop/utils/helpers";
import { RegisterStoreApiService } from "../../../services/register-store/register-store-api.service";
import { RegisterStoreDataService } from "../../../services/register-store/register-store-data.service";
import { RegexService } from "../../../services/shared/regex/regex.service";
import { WhiteshopLoginComponent } from "../whiteshop-login/whiteshop-login.component";
import { VerifyOtpStoreComponent } from "./verify-otp-store/verify-otp-store.component";
import { Router } from "@angular/router";

@Component({
  selector: "app-register-store",
  templateUrl: "./register-store.component.html",
  styleUrls: ["./register-store.component.scss"],
})
export class RegisterStoreComponent implements OnInit {
  public whiteShopIcon = icons.whiteShopIcon.icon;
  passwordType = "password";
  otp;
  windowHeight: number;
  windowWidth: number;
  passwordVisibility = false;
  passwordImg = icons.whiteShopIcon.eyeSlash;
  @ViewChild("passwordField") passwordField: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<RegisterStoreComponent>,
    public dialog: MatDialog,
    public localStorageService: LocalStorageService,
    public registerStoreApiService: RegisterStoreApiService,
    public dialogService: DialogService,
    public router: Router,
    public toastrService: ToastrService,
    public regexService: RegexService,
    public formBuilder: FormBuilder,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public registerStoreDataService: RegisterStoreDataService
  ) {}
  public validCompany = true;
  public registerForm = this.formBuilder.group({
    displayName: [""],
    username: ["", Validators.required],
    password: ["", [Validators.minLength(8), Validators.required]],
  });
  ngOnInit(): void {
    this.localStorageService.isLogoUpdated.subscribe((data) => {
      if (data && data.length) {
        this.whiteShopIcon = data[0];
      }
    });
    this.iconRegistry.addSvgIcon(
      "arrow_back",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrowBackBlack.svg"
      )
    );
    window.addEventListener("resize", () => {
      this.setDimensions();
    });
    this.setDimensions();
  }
  // get password() {
  //   return this.registerForm.controls['password'] as FormControl;
  // }
  backToHome() {
    this.dialogRef.close({ backToLogin: true });
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }

  isMobileDevice() {
    return this.windowWidth <= 6;
  }

  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 9;
  }

  registerStore() {
    const registerObject = {
      username: this.registerForm.controls.username.value,
      password: this.registerForm.controls.password.value,
    };
    registerObject["issendotp"] = true;
    if (this.data.type === "B2C") {
      registerObject["type"] = "B2C";
    } else {
      registerObject["companyName"] = "ShopConnect";
    }
    this.registerStoreDataService.registerStorePassword = this.registerForm.controls[
      "password"
    ].value;
    this.registerStoreApiService
      .postRegisterPreSignUpOtp(registerObject)
      .subscribe(
        (res) => {
          const data = res.user.status;
          if (data === "Activated") {
            this.toastrService.error("User already exists", null, {
              timeOut: 2000,
            });
          } else {
            console.log(res);
            this.toastrService.success("Otp sent", null, { timeOut: 2000 });
            let verifydialogRef = this.dialogService.openMatDialog(
              VerifyOtpStoreComponent,
              { data: res, type: this.data },
              false,
              false,
              null,
              true,
              true
            );
            verifydialogRef.afterClosed().subscribe(() => {
              this.dialogRef.close();
            });
          }
        },
        (err) => {
          if (err.error.user && err.error.user.status === "Verified") {
            // this.dialogService.openMatDialog(
            //   CreateCompanyComponent,
            //   err.error,
            //   true,
            //   false,
            //   null,
            //   true,
            //   true
            // );
            this.registerStoreDataService.companyRegisterData = err.error;
            this.router.navigateByUrl("my-company/createCompany");
            this.toastrService.success("User verified", null, {
              timeOut: 2000,
            });
            this.dialogRef.close();
          } else {
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        }
      );
  }

  validUserName() {
    return (
      this.registerForm.controls["username"].valid &&
      (this.regexService
        .getPhoneRegex()
        .test(this.registerForm.controls["username"].value) ||
        this.regexService
          .getEmailRegex()
          .test(this.registerForm.controls["username"].value))
    );
  }

  validLead() {
    return (
      this.validUserName() && this.registerForm.controls["password"].valid
      // this.validDisplayName()
      // this.registerForm.controls["password"].value.length >= 8
    );
  }

  validDisplayName() {
    return this.data.type === "B2C"
      ? this.registerForm.controls["displayName"].valid
      : true;
  }

  goToLogin() {
    this.dialogService.openMatDialog(
      WhiteshopLoginComponent,
      null,
      false,
      false,
      null,
      true,
      true
    );
    this.dialogRef.close();
  }

  togglePasswordVisibility() {
    if (this.passwordVisibility) {
      this.passwordVisibility = false;
      this.passwordType = "password";
      this.passwordImg = icons.whiteShopIcon.eyeSlash;
    } else {
      this.passwordVisibility = true;
      this.passwordType = "text";
      this.passwordImg = icons.whiteShopIcon.eye;
    }
    this.passwordField.nativeElement.focus();
  }

  submit() {
    if (this.validLead()) {
      this.registerStore();
    }
  }
}
